import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import AdsList from './List';
import AddOrEdit from './AddOrEdit';

class Ads extends Component {
  render() {
    return (
      <Switch>
        <Route
          path="/ads/add"
          exact
          render={routeProps => <AddOrEdit {...routeProps} editMode={false} />}
        />
        <Route
          path="/ads/edit"
          exact
          render={routeProps => <AddOrEdit {...routeProps} editMode={true} />}
        />
        <Route path="/" component={AdsList} />
      </Switch>
    );
  }
}

export default Ads;
